<template>
  <div class="home" id="home" :class="{'hide-branding': hideBranding, 'home--with-header': canUseHamburgerMenu}">
    <portal v-if="canUseHamburgerMenu" to="app-header-brand">
      <Logo v-if="!hideBranding" :homepage="homepage" />
    </portal>
    <Logo v-else-if="!hideBranding" :homepage="homepage" />
    <h3 v-if="!findError">
      {{ $t('Please enter your presentation\'s access code:') }}
    </h3>
    <h3 v-if="findError">
      {{ $t('Presentation not found. You may have mistyped the access code. Try again?') }}
    </h3>

    <form @submit.prevent="submitAccessCode" class="item-input">
      <input
        type="text"
        class="item-input-text submit-access-placeholder"
        :placeholder="$t('Type in access code...')"
        v-model="accessCode"
        @input="handleAccessCode"
        :maxlength="10"
        required
        data-testid="audience-join-access-code-input"
      >
      <div class="text-center flex justify-center">
        <aha-antd-button
          type="submit"
          size="lg"
          variant="primary-alt"
          isLoadingInline
          :loading="submiting"
          data-testid="audience-join-submit-button"
        >
          <span>{{ $t('submit') }}</span>
        </aha-antd-button>
      </div>
      <div class="text-danger text-center" v-if="error" style="line-height: 1.5rem">
        <svg viewBox="0 0 576 512" class="fa-fw">
          <!-- eslint-disable-next-line max-len -->
          <path d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" />
        </svg>
        <span v-html="error" />
      </div>
    </form>

    <p class="note text-center">
      {{ $t('The code is found on the screen in front of you.') }}
    </p>
  </div>
</template>

<script>
import sentry from '@/3rd-parties/sentry'

import Config from '@/config'
import Util from '@/util'
import { mapGetters } from 'vuex'
import Logo from '@/components/Logo'

export default {
  name: 'Home',
  components: {
    Logo,
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseHamburgerMenu']),
  },
  data() {
    return {
      accessCode: '',
      error: '',
      submiting: false,
      findError: false,
      hideBranding: false,
      homepage: true,
    }
  },
  created() {
    this.findError = Util.getParamValue('error', window.location.href)
    if (this.findError) {
      window.history.replaceState('', '', this.$router.resolve({ name: 'home' }).href)
    }
  },
  mounted() {
    if (window.location.host !== Config.domain) {
      this.hideBranding = true
    }
  },
  methods: {
    validateAcessCode() {
      this.$http
        .get(Config.api.checkPresentation, {
          params: {
            id: this.accessCode,
          },
        })
        .then((doc) => {
          if (!doc.body) {
            throw new Error('No presentation found')
          }
          // Only forward the marketplaceSandboxId param (needed for
          // marketplace sandbox testing); leave every other case untouched.
          const query = {}
          if (this.$route.query.marketplaceSandboxId) {
            query.marketplaceSandboxId = this.$route.query.marketplaceSandboxId
          }
          this.$router.push({
            name: 'presentation',
            params: { id: doc.body.uniqueAccessCode },
            query,
          })
          this.submiting = false
          return true
        })
        .catch((error) => {
          sentry.captureException(error)
          this.submiting = false
          this.error = this.$t('There\'s no such presentation with this access code ({code}). Please try again.', {
            code: `<span class="text-uppercase">${this.accessCode}</span>`,
          })
        })
    },

    submitAccessCode() {
      if (this.submiting) return
      this.submiting = true
      this.error = ''
      this.validateAcessCode()
    },

    handleAccessCode() {
      this.accessCode = this.accessCode.replace(/\s/g, '')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.home {
  background-color: #ffffff;
  color: #313131;
}

.note {
  padding: 0 16px;
  margin-top: 16px;
}

h3 {
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 20px;
  padding: 0 16px;
}
.home--with-header h3 {
  margin-top: 24px;
}
.hide-branding {
  h3 {
    margin-top: 40px;
  }
}
.fa-fw{
  text-align: center;
  width: 1.2em;
  margin-bottom: -2px;
}
.item-input {
  padding: 0 16px;
  max-width: 500px;
  margin: 0 auto;
  .item-input-text {
    margin-bottom: 16px;
    text-transform: uppercase;
  }

  .button-submit {
    width: 150px;
    .fas {
      margin-bottom: 4px;
    }
  }
}

.text-danger {
  margin-top: 20px;
  path{
    fill : #ff5050;
  }
}
.submit-access-placeholder::placeholder {
  text-transform: none;
}

</style>
